/**
@prefix adms: <http://www.w3.org/ns/adms#> .
@prefix owl: <http://www.w3.org/2002/07/owl#>.
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>.
@prefix dcat: <http://www.w3.org/ns/dcat#> .
@prefix dct: <http://purl.org/dc/terms/> .
@prefix foaf: <http://xmlns.com/foaf/0.1/> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix schema: <http://schema.org/> .
@prefix skos: <http://www.w3.org/2004/02/skos/core#> .
@prefix spdx: <http://spdx.org/rdf/terms#> .
@prefix v: <http://www.w3.org/2006/vcard/ns#> .
@prefix xsd: <http://www.w3.org/2001/XMLSchema#> . 
@prefix vann: <http://purl.org/vocab/vann/> .
@prefix voaf: <http://labs.mondeca.com/vocab/voaf#> .
@prefix wdrs: <http://www.w3.org/2007/05/powder-s#>.
 */
const content = `
@prefix : <http://www.w3.org/ns/adms#> .
@prefix v: <http://www.w3.org/2006/vcard/ns#> .
@prefix dct: <http://purl.org/dc/terms/> .
@prefix owl: <http://www.w3.org/2002/07/owl#> .
@prefix rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> .
@prefix xml: <http://www.w3.org/XML/1998/namespace> .
@prefix xsd: <http://www.w3.org/2001/XMLSchema#> .
@prefix adms: <http://www.w3.org/ns/adms#> .
@prefix dcat: <http://www.w3.org/ns/dcat#> .
@prefix foaf: <http://xmlns.com/foaf/0.1/> .
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#> .
@prefix skos: <http://www.w3.org/2004/02/skos/core#> .
@prefix spdx: <http://spdx.org/rdf/terms#> .
@prefix vann: <http://purl.org/vocab/vann/> .
@prefix voaf: <http://labs.mondeca.com/vocab/voaf#> .
@prefix wdrs: <http://www.w3.org/2007/05/powder-s#> .
@prefix schema: <http://schema.org/> .
@base <http://www.w3.org/ns/adms#> .

<http://www.w3.org/ns/adms#> rdf:type owl:Ontology ;
                              voaf:specializes dcat: ;
                              dct:abstract "ADMS is a profile of DCAT, used to describe semantic assets (or just 'Assets'), defined as highly reusable metadata (e.g. xml schemata, generic data models) and reference data (e.g. code lists, taxonomies, dictionaries, vocabularies) that are used for eGovernment system development."@en ;
                              dct:creator _:genid1 ,
                                          _:genid3 ,
                                          _:genid4 ;
                              vann:preferredNamespacePrefix "adms" ;
                              vann:preferredNamespaceUri "http://www.w3.org/ns/adms#" ;
                              rdfs:comment "This file specifies the set of RDF classes and properties used in ADMS-AP"@en ;
                              rdfs:label "Asset Description Metadata Schema - Application Profile(ADMS-AP)"@en ;
                              wdrs:describedby <http://www.w3.org/TR/vocab-adms> ;
                              foaf:maker _:genid5 .

_:genid1 foaf:homepage <http://andrea-perego.name/> ;
          foaf:name "Andrea Perego" ;
          schema:affiliation _:genid2 ;
          rdfs:seeAlso <http://andrea-perego.name/foaf/#me> .

_:genid3 foaf:homepage <http://makxdekkers.com/> ;
          foaf:name "Makx Dekkers" ;
          rdfs:seeAlso <http://makxdekkers.com/makxdekkers.rdf#me> .

_:genid4 foaf:homepage <http://www.w3.org/People/all#phila> ;
          foaf:name "Phil Archer" ;
          schema:affiliation <http://www.w3.org/data#W3C> ;
          rdfs:seeAlso <http://philarcher.org/foaf.rdf#me> .

_:genid5 foaf:homepage <http://www.w3.org/2011/gld/> ;
          foaf:name "Government Linked Data WG, based on output from the ADMS Working Group" .

_:genid2 foaf:homepage <http://ies.jrc.ec.europa.eu/DE> ;
          foaf:name "European Commission, Joint Research Centre " .

#################################################################
#    Annotation properties
#################################################################

###  http://labs.mondeca.com/vocab/voaf#specializes
voaf:specializes rdf:type owl:AnnotationProperty .


###  http://purl.org/dc/terms/abstract
dct:abstract rdf:type owl:AnnotationProperty .


###  http://purl.org/dc/terms/creator
dct:creator rdf:type owl:AnnotationProperty .


###  http://purl.org/vocab/vann/preferredNamespacePrefix
vann:preferredNamespacePrefix rdf:type owl:AnnotationProperty ;
                              rdfs:domain dcat:Dataset .


###  http://purl.org/vocab/vann/preferredNamespaceUri
vann:preferredNamespaceUri rdf:type owl:AnnotationProperty ;
                           rdfs:domain dcat:Dataset .


###  http://purl.org/vocab/vann/usageNote
vann:usageNote rdf:type owl:AnnotationProperty .


###  http://schema.org/affiliation
schema:affiliation rdf:type owl:AnnotationProperty .


###  http://www.w3.org/2000/01/rdf-schema#label
rdfs:label rdfs:domain dcat:Dataset .


###  http://www.w3.org/2007/05/powder-s#describedby
wdrs:describedby rdf:type owl:AnnotationProperty .


###  http://xmlns.com/foaf/0.1/maker
foaf:maker rdf:type owl:AnnotationProperty .


#################################################################
#    Datatypes
#################################################################

###  http://www.w3.org/2001/XMLSchema#date
xsd:date rdf:type rdfs:Datatype .


#################################################################
#    Object Properties
#################################################################

###  http://purl.org/dc/terms/format
dct:format rdf:type owl:ObjectProperty ;
           rdfs:range dct:MediaTypeOrExtent .


###  http://purl.org/dc/terms/hasVersion
dct:hasVersion rdf:type owl:ObjectProperty ;
               rdfs:range dcat:Dataset .


###  http://purl.org/dc/terms/isVersionOf
dct:isVersionOf rdf:type owl:ObjectProperty ;
                rdfs:domain dcat:Dataset ;
                rdfs:range dcat:Dataset .


###  http://purl.org/dc/terms/language
dct:language rdf:type owl:ObjectProperty ;
             rdfs:domain dcat:Dataset ;
             rdfs:range dct:LinguisticSystem .


###  http://purl.org/dc/terms/licence
dct:licence rdf:type owl:ObjectProperty ;
            rdfs:range dct:LicenceDocument .


###  http://purl.org/dc/terms/publisher
dct:publisher rdf:type owl:ObjectProperty ;
              rdfs:domain dcat:Dataset ;
              rdfs:range foaf:Agent .


###  http://purl.org/dc/terms/relation
dct:relation rdf:type owl:ObjectProperty ;
             rdfs:range rdfs:Resource .


###  http://purl.org/dc/terms/spatial
dct:spatial rdf:type owl:ObjectProperty ;
            rdfs:range dct:Location .


###  http://purl.org/dc/terms/type
dct:type rdf:type owl:ObjectProperty ;
         rdfs:range skos:Concept .


###  http://spdx.org/rdf/terms#algorithm
spdx:algorithm rdf:type owl:ObjectProperty ;
               rdfs:range spdx:checksumAlgorithm_sha1 .


###  http://spdx.org/rdf/terms#checksum
spdx:checksum rdf:type owl:ObjectProperty ;
              rdfs:range spdx:Checksum .


###  http://www.w3.org/2004/02/skos/core#inScheme
skos:inScheme rdf:type owl:ObjectProperty ;
              rdfs:range skos:ConceptScheme .


###  http://www.w3.org/2006/vcard/ns#hasAddress
v:hasAddress rdf:type owl:ObjectProperty ;
             rdfs:range v:Address .


###  http://www.w3.org/2006/vcard/ns#hasEmail
v:hasEmail rdf:type owl:ObjectProperty ;
           rdfs:range v:Email .


###  http://www.w3.org/ns/adms#includedAsset
adms:includedAsset rdf:type owl:ObjectProperty ;
                   rdfs:domain dcat:Dataset ;
                   rdfs:range dcat:Dataset .


###  http://www.w3.org/ns/adms#representationTechnique
adms:representationTechnique rdf:type owl:ObjectProperty ;
                             rdfs:range skos:Concept .


###  http://www.w3.org/ns/adms#status
adms:status rdf:type owl:ObjectProperty ;
            rdfs:range skos:Concept .


###  http://www.w3.org/ns/adms#translation
adms:translation rdf:type owl:ObjectProperty ;
                 rdfs:domain dcat:Dataset ;
                 rdfs:range dcat:Dataset .


###  http://www.w3.org/ns/dcat#accessURL
dcat:accessURL rdf:type owl:ObjectProperty ;
               rdfs:range rdfs:Resource .


###  http://www.w3.org/ns/dcat#contactPoint
dcat:contactPoint rdf:type owl:ObjectProperty ;
                  rdfs:domain dcat:Dataset ;
                  rdfs:range v:Kind ,
                             v:vKind .


###  http://www.w3.org/ns/dcat#dataset
dcat:dataset rdf:type owl:ObjectProperty ;
             rdfs:range dcat:Dataset .


###  http://www.w3.org/ns/dcat#distribution
dcat:distribution rdf:type owl:ObjectProperty ;
                  rdfs:range dcat:Distribution .


###  http://www.w3.org/ns/dcat#landingPage
dcat:landingPage rdf:type owl:ObjectProperty ;
                 rdfs:range foaf:Document .


###  http://www.w3.org/ns/dcat#theme
dcat:theme rdf:type owl:ObjectProperty ;
           rdfs:range skos:Concept .


###  http://www.w3.org/ns/dcat#themeTaxonomy
dcat:themeTaxonomy rdf:type owl:ObjectProperty ;
                   rdfs:range skos:ConceptScheme .


###  http://xmlns.com/foaf/0.1/homepage
foaf:homepage rdf:type owl:ObjectProperty ;
              rdfs:domain dcat:Dataset ;
              rdfs:range foaf:Document .


###  http://xmlns.com/foaf/0.1/page
foaf:page rdf:type owl:ObjectProperty ;
          rdfs:range foaf:Document .


#################################################################
#    Data properties
#################################################################

###  http://purl.org/dc/terms/description
dct:description rdf:type owl:DatatypeProperty ;
                rdfs:domain dcat:Dataset ;
                rdfs:range rdfs:Literal .


###  http://purl.org/dc/terms/identifier
dct:identifier rdf:type owl:DatatypeProperty ;
               rdfs:range rdfs:Literal .


###  http://purl.org/dc/terms/issued
dct:issued rdf:type owl:DatatypeProperty ;
           rdfs:range rdfs:Literal .


###  http://purl.org/dc/terms/modified
dct:modified rdf:type owl:DatatypeProperty ;
             rdfs:range rdfs:Literal .


###  http://purl.org/dc/terms/title
dct:title rdf:type owl:DatatypeProperty ;
          rdfs:domain dcat:Dataset ;
          rdfs:range rdfs:Literal .


###  http://schema.org/fileSize
schema:fileSize rdf:type owl:DatatypeProperty ;
                rdfs:range rdfs:Literal .


###  http://spdx.org/rdf/terms#checksumValue
spdx:checksumValue rdf:type owl:DatatypeProperty ;
                   rdfs:range rdfs:Literal .


###  http://www.w3.org/2000/01/rdf-schema#label
rdfs:label rdf:type owl:DatatypeProperty ;
           rdfs:range rdfs:Literal .


###  http://www.w3.org/2002/07/owl#versionInfo
owl:versionInfo rdf:type owl:DatatypeProperty ;
                rdfs:domain dcat:Dataset ;
                rdfs:range rdfs:Literal .


###  http://www.w3.org/2004/02/skos/core#altLabel
skos:altLabel rdf:type owl:DatatypeProperty ;
              rdfs:range rdfs:Literal .


###  http://www.w3.org/2004/02/skos/core#hasTopConcept
skos:hasTopConcept rdf:type owl:DatatypeProperty ;
                   rdfs:range rdfs:Literal .


###  http://www.w3.org/2004/02/skos/core#label
skos:label rdf:type owl:DatatypeProperty ;
           rdfs:range rdfs:Literal .


###  http://www.w3.org/2006/vcard/ns#fn
v:fn rdf:type owl:DatatypeProperty ;
     rdfs:range rdfs:Literal .


###  http://www.w3.org/2006/vcard/ns#hasTelephone
v:hasTelephone rdf:type owl:DatatypeProperty ;
               rdfs:range rdfs:Literal .


###  http://www.w3.org/2006/vcard/ns#hasURL
v:hasURL rdf:type owl:DatatypeProperty ;
         rdfs:range rdfs:Literal .


###  http://www.w3.org/ns/adms#status
adms:status rdf:type owl:DatatypeProperty .


###  http://www.w3.org/ns/adms#versionNotes
adms:versionNotes rdf:type owl:DatatypeProperty ;
                  rdfs:range rdfs:Literal .


###  http://www.w3.org/ns/dcat#keyword
dcat:keyword rdf:type owl:DatatypeProperty ;
             rdfs:range rdfs:Literal .


###  http://xmlns.com/foaf/0.1/name
foaf:name rdf:type owl:DatatypeProperty ;
          rdfs:range rdfs:Literal .


#################################################################
#    Classes
#################################################################

###  http://labs.mondeca.com/vocab/voaf#Vocabulary
voaf:Vocabulary rdf:type owl:Class .


###  http://purl.org/dc/terms/LicenceDocument
dct:LicenceDocument rdf:type owl:Class .


###  http://purl.org/dc/terms/LinguisticSystem
dct:LinguisticSystem rdf:type owl:Class .


###  http://purl.org/dc/terms/Location
dct:Location rdf:type owl:Class .


###  http://purl.org/dc/terms/MediaTypeOrExtent
dct:MediaTypeOrExtent rdf:type owl:Class .


###  http://spdx.org/rdf/terms#Checksum
spdx:Checksum rdf:type owl:Class .


###  http://spdx.org/rdf/terms#checksumAlgorithm_sha1
spdx:checksumAlgorithm_sha1 rdf:type owl:Class .


###  http://www.w3.org/2000/01/rdf-schema#Resource
rdfs:Resource rdf:type owl:Class .


###  http://www.w3.org/2004/02/skos/core#Concept
skos:Concept rdf:type owl:Class .


###  http://www.w3.org/2004/02/skos/core#ConceptScheme
skos:ConceptScheme rdf:type owl:Class .


###  http://www.w3.org/2006/vcard/ns#Address
v:Address rdf:type owl:Class .


###  http://www.w3.org/2006/vcard/ns#Email
v:Email rdf:type owl:Class .


###  http://www.w3.org/2006/vcard/ns#Kind
v:Kind rdf:type owl:Class .


###  http://www.w3.org/2006/vcard/ns#vKind
v:vKind rdf:type owl:Class .


###  http://www.w3.org/ns/dcat#Catalog
dcat:Catalog rdf:type owl:Class .


###  http://www.w3.org/ns/dcat#Dataset
dcat:Dataset rdf:type owl:Class .


###  http://www.w3.org/ns/dcat#Distribution
dcat:Distribution rdf:type owl:Class .


###  http://xmlns.com/foaf/0.1/Agent
foaf:Agent rdf:type owl:Class .


###  http://xmlns.com/foaf/0.1/Document
foaf:Document rdf:type owl:Class .


#################################################################
#    Individuals
#################################################################

###  http://andrea-perego.name/
<http://andrea-perego.name/> rdf:type owl:NamedIndividual .


###  http://ies.jrc.ec.europa.eu/DE
<http://ies.jrc.ec.europa.eu/DE> rdf:type owl:NamedIndividual .


###  http://makxdekkers.com/
<http://makxdekkers.com/> rdf:type owl:NamedIndividual .


###  http://purl.org/dc/terms/LicenceDocument
dct:LicenceDocument rdf:type owl:NamedIndividual ;
                    dct:identifier "dct:LicenceDocument"@en ;
                    rdfs:label "Licence"@en .


###  http://purl.org/dc/terms/LinguisticSystem
dct:LinguisticSystem rdf:type owl:NamedIndividual ;
                     dct:identifier "dct:LinguisticSystem"@en ;
                     rdfs:label "Language"@en .


###  http://purl.org/dc/terms/Location
dct:Location rdf:type owl:NamedIndividual ;
             dct:identifier "dct:Location"@en ;
             rdfs:label "Geographical Coverage"@en .


###  http://purl.org/dc/terms/MediaTypeOrExtent
dct:MediaTypeOrExtent rdf:type owl:NamedIndividual ;
                      dct:identifier "dct:MediaTypeOrExtent"@en ;
                      rdfs:label "Media Type"@en .


###  http://purl.org/dc/terms/description
dct:description rdf:type owl:NamedIndividual ;
                dct:identifier "dct:description"@en ;
                rdfs:label "Asset - description"@en ,
                           "Asset Distribution - description"@en ,
                           "Asset Repository - description"@en ,
                           "Licence - description"@en .


###  http://purl.org/dc/terms/format
dct:format rdf:type owl:NamedIndividual ;
           dct:identifier "dct:format"@en ;
           rdfs:label "Asset Distribution - format"@en .


###  http://purl.org/dc/terms/hasVersion
dct:hasVersion rdf:type owl:NamedIndividual ;
               dct:identifier "dct:hasVersion"@en ;
               rdfs:label "Asset - has Version"@en .


###  http://purl.org/dc/terms/identifier
dct:identifier rdf:type owl:NamedIndividual ;
               dct:identifier "dct:identifier"@en ;
               rdfs:label "Asset - identifier"@en .


###  http://purl.org/dc/terms/isVersionOf
dct:isVersionOf rdf:type owl:NamedIndividual ;
                dct:identifier "dct:isVersionOf"@en ;
                rdfs:label "Asset - is Version Of"@en .


###  http://purl.org/dc/terms/issued
dct:issued rdf:type owl:NamedIndividual ;
           dct:identifier "dct:issued"@en ;
           rdfs:label "Asset - issued"@en ,
                      "Asset Distribution - issued"@en ,
                      "Asset Repository - issued"@en .


###  http://purl.org/dc/terms/language
dct:language rdf:type owl:NamedIndividual ;
             dct:identifier "dct:language"@en ;
             rdfs:label "Asset - language"@en .


###  http://purl.org/dc/terms/licence
dct:licence rdf:type owl:NamedIndividual ;
            dct:identifier "dct:licence"@en ;
            rdfs:label "Asset Distribution - licence"@en .


###  http://purl.org/dc/terms/modified
dct:modified rdf:type owl:NamedIndividual ;
             dct:identifier "dct:modified"@en ;
             rdfs:label "Asset - modified"@en ,
                        "Asset Distribution - modified"@en .


###  http://purl.org/dc/terms/publisher
dct:publisher rdf:type owl:NamedIndividual ;
              dct:identifier "dct:publisher"@en ;
              rdfs:label "Asset - publisher"@en ,
                         "Asset Distribution - publisher"@en ,
                         "Asset Repository - publisher"@en .


###  http://purl.org/dc/terms/relation
dct:relation rdf:type owl:NamedIndividual ;
             dct:identifier "dct:relation"@en ;
             rdfs:label "Asset - relation"@en .


###  http://purl.org/dc/terms/spatial
dct:spatial rdf:type owl:NamedIndividual ;
            dct:identifier "dct:spatial"@en ;
            rdfs:label "Asset - spatial"@en ,
                       "Asset Repository - spatial"@en .


###  http://purl.org/dc/terms/title
dct:title rdf:type owl:NamedIndividual ;
          dct:identifier "dct:title"@en ;
          rdfs:label "Asset - title"@en ,
                     "Asset Distribution - title"@en ,
                     "Asset Repository - title"@en .


###  http://purl.org/dc/terms/type
dct:type rdf:type owl:NamedIndividual ;
         dct:identifier "dct:type"@en ;
         rdfs:label "Asset - type"@en ,
                    "Licence - type"@en ,
                    "Publisher - type"@en .


###  http://schema.org/fileSize
schema:fileSize rdf:type owl:NamedIndividual ;
                dct:identifier "schema:fileSize"@en ;
                rdfs:label "Asset Distribution - file Size"@en .


###  http://spdx.org/rdf/terms#Checksum
spdx:Checksum rdf:type owl:NamedIndividual ;
              dct:identifier "spdx:Checksum"@en ;
              rdfs:label "Checksum"@en .


###  http://spdx.org/rdf/terms#algorithm
spdx:algorithm rdf:type owl:NamedIndividual ;
               dct:identifier "spdx:algorithm"@en ;
               rdfs:label "Checksum - algorithm"@en .


###  http://spdx.org/rdf/terms#checksum
spdx:checksum rdf:type owl:NamedIndividual ;
              dct:identifier "spdx:checksum"@en ;
              rdfs:label "Asset Distribution - checksum"@en .


###  http://spdx.org/rdf/terms#checksumValue
spdx:checksumValue rdf:type owl:NamedIndividual ;
                   dct:identifier "spdx:checksumValue"@en ;
                   rdfs:label "Checksum - checksum Value"@en .


###  http://www.w3.org/2000/01/rdf-schema#label
rdfs:label rdf:type owl:NamedIndividual ;
           dct:identifier "rdfs:label"@en ;
           rdfs:label "Geographical Coverage - label"@en ,
                      "Language - label"@en ,
                      "Licence - label"@en ,
                      "Media Type - label"@en ,
                      "Theme Taxonomy - label"@en .


###  http://www.w3.org/2002/07/owl#versionInfo
owl:versionInfo rdf:type owl:NamedIndividual ;
                dct:identifier "owl:versionInfo"@en ;
                rdfs:label "Asset - version Info"@en .


###  http://www.w3.org/2004/02/skos/core#Concept
skos:Concept rdf:type owl:NamedIndividual ;
             dct:identifier "skos:Concept"@en ;
             rdfs:label "Asset type"@en ,
                        "Interoperability Level"@en ,
                        "Representation Technique"@en ,
                        "Status"@en ,
                        "Theme"@en .


###  http://www.w3.org/2004/02/skos/core#ConceptScheme
skos:ConceptScheme rdf:type owl:NamedIndividual ;
                   dct:identifier "skos:ConceptScheme"@en ;
                   rdfs:label "Theme Taxonomy"@en .


###  http://www.w3.org/2004/02/skos/core#altLabel
skos:altLabel rdf:type owl:NamedIndividual ;
              dct:identifier "skos:altLabel"@en ;
              rdfs:label "Asset - alt Label"@en .


###  http://www.w3.org/2004/02/skos/core#hasTopConcept
skos:hasTopConcept rdf:type owl:NamedIndividual ;
                   dct:identifier "skos:hasTopConcept"@en ;
                   rdfs:label "Theme Taxonomy - has Top Concept"@en .


###  http://www.w3.org/2004/02/skos/core#inScheme
skos:inScheme rdf:type owl:NamedIndividual ;
              dct:identifier "skos:inScheme"@en ;
              rdfs:label "Asset Type - in Scheme"@en ,
                         "Interoperability Level - in Scheme"@en ,
                         "Representation Technique - in Scheme"@en ,
                         "Status - in Scheme"@en ,
                         "Theme - in Scheme"@en .


###  http://www.w3.org/2004/02/skos/core#label
skos:label rdf:type owl:NamedIndividual ;
           dct:identifier "skos:label"@en ;
           rdfs:label "Asset Type - label"@en ,
                      "Interoperability Level - label"@en ,
                      "Representation Technique - label"@en ,
                      "Status - label"@en ,
                      "Theme - label"@en .


###  http://www.w3.org/2006/vcard/ns#Kind
v:Kind rdf:type owl:NamedIndividual ;
       dct:identifier "v:Kind"@en ;
       rdfs:label "Contact Information"@en .


###  http://www.w3.org/2006/vcard/ns#fn
v:fn rdf:type owl:NamedIndividual ;
     dct:identifier "v:fn"@en ;
     rdfs:label "Contact Information - full name"@en .


###  http://www.w3.org/2006/vcard/ns#hasAddress
v:hasAddress rdf:type owl:NamedIndividual ;
             dct:identifier "v:hasAddress"@en ;
             rdfs:label "Contact Information - has Address"@en .


###  http://www.w3.org/2006/vcard/ns#hasEmail
v:hasEmail rdf:type owl:NamedIndividual ;
           dct:identifier "v:hasEmail"@en ;
           rdfs:label "Contact Information - has Email"@en .


###  http://www.w3.org/2006/vcard/ns#hasTelephone
v:hasTelephone rdf:type owl:NamedIndividual ;
               dct:identifier "v:hasTelephone"@en ;
               rdfs:label "Contact Information - has Telephone"@en .


###  http://www.w3.org/2006/vcard/ns#hasURL
v:hasURL rdf:type owl:NamedIndividual ;
         dct:identifier "v:hasURL"@en ;
         rdfs:label "Contact Information - has URL"@en .


###  http://www.w3.org/2011/gld/
<http://www.w3.org/2011/gld/> rdf:type owl:NamedIndividual .


###  http://www.w3.org/People/all#phila
<http://www.w3.org/People/all#phila> rdf:type owl:NamedIndividual .


###  http://www.w3.org/ns/adms#
<http://www.w3.org/ns/adms#> rdf:type owl:NamedIndividual ,
                                      voaf:Vocabulary ;
                             dct:description """This is the RDF encoding of the Asset Description Metadata Schema, originally 
    developed under the European Union's ISA Programme and further developed by the W3C Government Linked Data Working Group.
    It re-uses terms from several other vocabularies, notably Dublin Core, with elements of SKOS, FOAF and more. """ ;
                             dct:modified "2016-5-11"^^xsd:date ;
                             dct:title "Asset Description Metadata Schema - Application Profile(ADMS-AP)"@en .


###  http://www.w3.org/ns/adms#includedAsset
adms:includedAsset rdf:type owl:NamedIndividual ;
                   dct:identifier "adms:includedAsset"@en ;
                   rdfs:label "Asset - includedAsset"@en .


###  http://www.w3.org/ns/adms#representationTechnique
adms:representationTechnique rdf:type owl:NamedIndividual ;
                             dct:identifier "adms:representationTechnique"@en ;
                             rdfs:label "Asset Distribution - representation Technique"@en .


###  http://www.w3.org/ns/adms#status
adms:status rdf:type owl:NamedIndividual ;
            dct:identifier "adms:status"@en ;
            rdfs:label "Asset - status"@en ,
                       "Asset Distribution - version Notes"@en .


###  http://www.w3.org/ns/adms#translation
adms:translation rdf:type owl:NamedIndividual ;
                 dct:identifier "adms:translation"@en ;
                 rdfs:label "Asset - translation"@en .


###  http://www.w3.org/ns/adms#versionNotes
adms:versionNotes rdf:type owl:NamedIndividual ;
                  dct:identifier "adms:versionNotes"@en ;
                  rdfs:label "Asset - version Notes"@en .


###  http://www.w3.org/ns/dcat#Catalog
dcat:Catalog rdf:type owl:NamedIndividual ;
             dct:identifier "dcat:Catalog"@en ;
             rdfs:label "Asset Repository"@en .


###  http://www.w3.org/ns/dcat#Dataset
dcat:Dataset rdf:type owl:NamedIndividual ;
             dct:identifier "dcat:Dataset"@en ;
             rdfs:label "Asset"@en .


###  http://www.w3.org/ns/dcat#Distribution
dcat:Distribution rdf:type owl:NamedIndividual ;
                  dct:identifier "dcat:Distribution"@en ;
                  rdfs:label "Asset Distribution"@en .


###  http://www.w3.org/ns/dcat#accessURL
dcat:accessURL rdf:type owl:NamedIndividual ;
               dct:identifier "dcat:accessURL"@en ;
               rdfs:label "Asset Distribution - access URL"@en .


###  http://www.w3.org/ns/dcat#contactPoint
dcat:contactPoint rdf:type owl:NamedIndividual ;
                  dct:identifier "dcat:contactPoint"@en ;
                  rdfs:label "Asset - contact point"@en ,
                             "Asset Repository - contact Point"@en .


###  http://www.w3.org/ns/dcat#dataset
dcat:dataset rdf:type owl:NamedIndividual ;
             dct:identifier "dcat:dataset"@en ;
             rdfs:label "Asset Repository - dataset"@en .


###  http://www.w3.org/ns/dcat#distribution
dcat:distribution rdf:type owl:NamedIndividual ;
                  dct:identifier "dcat:distribution"@en ;
                  rdfs:label "Asset - distribution"@en .


###  http://www.w3.org/ns/dcat#keyword
dcat:keyword rdf:type owl:NamedIndividual ;
             dct:identifier "dcat:keyword"@en ;
             rdfs:label "Asset - keyword"@en ,
                        "Asset Repository - keyword"@en .


###  http://www.w3.org/ns/dcat#landingPage
dcat:landingPage rdf:type owl:NamedIndividual ;
                 dct:identifier "dcat:landingPage"@en ;
                 rdfs:label "Asset - landing Page"@en .


###  http://www.w3.org/ns/dcat#theme
dcat:theme rdf:type owl:NamedIndividual ;
           dct:identifier "dcat:theme"@en ;
           rdfs:label "Asset - theme"@en .


###  http://www.w3.org/ns/dcat#themeTaxonomy
dcat:themeTaxonomy rdf:type owl:NamedIndividual ;
                   dct:identifier "dcat:themeTaxonomy"@en ;
                   rdfs:label "Asset Repository - theme Taxonomy"@en .


###  http://xmlns.com/foaf/0.1/Agent
foaf:Agent rdf:type owl:NamedIndividual ;
           dct:identifier "foaf:Agent"@en ;
           rdfs:label "Publisher"@en .


###  http://xmlns.com/foaf/0.1/Document
foaf:Document rdf:type owl:NamedIndividual ;
              dct:identifier "foaf:Document"@en ;
              rdfs:label "Documentation"@en .


###  http://xmlns.com/foaf/0.1/homepage
foaf:homepage rdf:type owl:NamedIndividual ;
              dct:identifier "foaf:homepage"@en ;
              rdfs:label "Asset Repository - homepage"@en .


###  http://xmlns.com/foaf/0.1/name
foaf:name rdf:type owl:NamedIndividual ;
          dct:identifier "foaf:name"@en ;
          rdfs:label "Publisher - name"@en .


###  http://xmlns.com/foaf/0.1/page
foaf:page rdf:type owl:NamedIndividual ;
          dct:identifier "foaf:page"@en ;
          rdfs:label "Asset - page"@en .


_:genid1 foaf:homepage <http://andrea-perego.name/> ;
         foaf:name "Andrea Perego" ;
         schema:affiliation _:genid2 ;
         rdfs:seeAlso <http://andrea-perego.name/foaf/#me> .

_:genid3 foaf:homepage <http://makxdekkers.com/> ;
          foaf:name "Makx Dekkers" ;
          rdfs:seeAlso <http://makxdekkers.com/makxdekkers.rdf#me> .

_:genid5 foaf:homepage <http://www.w3.org/2011/gld/> ;
          foaf:name "Government Linked Data WG, based on output from the ADMS Working Group" .

_:genid4 foaf:homepage <http://www.w3.org/People/all#phila> ;
          foaf:name "Phil Archer" ;
          schema:affiliation <http://www.w3.org/data#W3C> ;
          rdfs:seeAlso <http://philarcher.org/foaf.rdf#me> .

#################################################################
#    Annotations
#################################################################

dct:LicenceDocument rdfs:isDefinedBy dct: ;
                     vann:usageNote "Optional class"@en ;
                     rdfs:comment "Conditions or restrictions that apply to the use of a Repository or Distribution, e.g. whether it is in the public domain, or that some restrictions apply such as attribution being required, or that it can only be used for non-commercial purposes etc."@en .


dct:LinguisticSystem rdfs:comment "Language of an Asset that contains textual information, e.g. the language of the terms in a controlled vocabulary or the language in which a document is written."@en ;
                     vann:usageNote "Optional class"@en ;
                     rdfs:isDefinedBy dct: .


dct:Location rdfs:comment "Document that further describes an Asset or gives guidelines for its use."@en ;
             vann:usageNote "Optional class"@en ;
             rdfs:isDefinedBy dct: .


dct:MediaTypeOrExtent vann:usageNote "Optional class"@en ;
                      rdfs:isDefinedBy dct: ;
                      rdfs:comment "Technical format in which a Distribution is available, e.g. PDF, XSD etc."@en .


dct:description rdfs:comment "Descriptive text for the Asset."@en ;
                vann:usageNote "Recommended Property - 0..n"@en ;
                rdfs:comment "Descriptive text for the Distribution."@en ;
                vann:usageNote "Mandatory Property - 1..n"@en ;
                rdfs:comment "Descriptive text for the Repository."@en ,
                             "Description of the Licence."@en ;
                rdfs:isDefinedBy dct: ;
                vann:usageNote "Optional Property - 0..n"@en .


dct:format rdfs:comment "Media type of the Distribution, using a controlled vocabulary - MDR File Type Name Authority List >> http://publications.europa.eu/resource/authority/file-type "@en ;
           rdfs:isDefinedBy dct: ;
           vann:usageNote "Recommended Property - 0..1"@en .


dct:hasVersion rdfs:isDefinedBy dct: ;
               vann:usageNote "Optional Property - 0..n"@en ;
               rdfs:comment "An Asset that is a release of this Asset."@en .


dct:identifier rdfs:comment "Main identifier for the Asset, e.g. the URI or other unique identifier in the context of the Repository."@en ;
               rdfs:isDefinedBy dct: ;
               vann:usageNote "Optional Property - 0..n"@en .


dct:isVersionOf rdfs:isDefinedBy dct: ;
                rdfs:comment "An Asset that is the solution of which this Asset is a release."@en ;
                vann:usageNote "Optional Property - 0..1"@en .


dct:issued vann:usageNote "rdfs:Literal typed as xsd:dateTime. Optional Property - 0..1"@en ,
                          "rdfs:Literal typed as xsd:DateTime. Optional Property - 0..1"@en ;
           rdfs:comment "Date of formal issuance of this version of the Asset."@en ;
           rdfs:isDefinedBy dct: ;
           rdfs:comment "Date of formal issuance of this version of the Distribution."@en ,
                        "Date of formal issuance of the Repository."@en ;
           vann:usageNote "rdfs:Literal typed as xsd:dateTime. Optional Property - 0..n"@en .


dct:language rdfs:comment "Language of the Asset, or language supported by software, using a controlled vocabulary - MDR Languages Named Authority List >> http://publications.europa.eu/resource/authority/language"@en ;
             vann:usageNote "Recommended Property - 0..n"@en ;
             rdfs:isDefinedBy dct: .


dct:licence rdfs:isDefinedBy dct: ;
            vann:usageNote "Mandatory Property - 1..1"@en ;
            rdfs:comment "Conditions or restrictions for (re)use of the Distribution; if there are multiple licences, the most 'open' one should be given. Whenever relevant, the URIs under the concept scheme identified by http://purl.org/adms/OSIlicence/ can be used."@en .


dct:modified rdfs:isDefinedBy dct: ;
             vann:usageNote "rdfs:Literal typed as xsd:dateTime. Optional Property - 0..1"@en ,
                            "rdfs:Literal typed as xsd:DateTime. Optional Property - 0..1"@en ;
             rdfs:comment "Date of latest update of this Distribution."@en ,
                          "Date of latest update of this Asset."@en .


dct:publisher vann:usageNote "Mandatory Property - 1..1"@en ,
                             "Mandatory Property - 1..n"@en ;
              rdfs:comment "Organisation making the Distribution available; the publisher is the Agent that publishes the Distribution, not the Agent that publishes the metadata about it."@en ,
                           "Organisation making the Asset available; the publisher is the Agent that publishes the Asset, not the Agent that publishes the metadata about it."@en ;
              vann:usageNote "Optional Property - 0..n"@en ;
              rdfs:isDefinedBy dct: ;
              rdfs:comment "Organisation making the Repository available; the publisher is the Agent that publishes the Repository, not the Agent that publishes the metadata about it."@en .


dct:relation rdfs:isDefinedBy dct: ;
             rdfs:comment "Related resource, in particular a related asset."@en ;
             vann:usageNote "Recommended Property - 0..n"@en .


dct:spatial rdfs:comment "Geographic region or jurisdiction to which the Asset applies, using a controlled vocabulary - MDR Countries Named Authority List >> http://publications.europa.eu/resource/authority/country ; MDR Places Named Authority List >> http://publications.europa.eu/resource/authority/place/"@en ;
            rdfs:isDefinedBy dct: ;
            rdfs:comment "Geographic region or jurisdiction to which the Repository applies, using a controlled vocabulary - MDR Countries Named Authority List >> http://publications.europa.eu/resource/authority/country ; MDR Places Named Authority List >> http://publications.europa.eu/resource/authority/place/"@en ;
            vann:usageNote "Recommended Property - 0..n"@en .


dct:title vann:usageNote "Optional Property - 0..n"@en ,
                         "Mandatory Property - 1..n"@en ;
          rdfs:isDefinedBy dct: ;
          rdfs:comment "Name of the Distribution."@en ,
                       "Name of the Asset."@en ,
                       "Name of the Repository."@en .


dct:type rdfs:comment "Label for the Interoperability Level - ADMS Licence Type vocabulary >> http://purl.org/adms/licencetype/ ; use only one of the four terms     :PublicDomain, :OSIcompliant, :NonOSIcompliant, :UnknownIPR"@en ;
         rdfs:isDefinedBy dct: ;
         vann:usageNote "Mandatory Property - 1..n"@en ,
                        "Mandatory Property - 1..1"@en ,
                        "Recommended Property - 0..n"@en ;
         rdfs:comment "Type of the Asset, using a controlled vocabulary - EIRA vocabulary >> https://joinup.ec.europa.eu/svn/eia/taxonomy/EIRA_SKOS.rdf"@en ,
                      "The type of publisher - ADMS Publisher Type vocabulary >> http://purl.org/adms/publishertype/"@en .


schema:fileSize vann:usageNote "Optional Property - 0..1"@en ;
                rdfs:isDefinedBy schema: ;
                rdfs:comment "Size of the file of the distribution."@en .


spdx:Checksum rdfs:isDefinedBy spdx: ;
              vann:usageNote "Optional class"@en ;
              rdfs:comment "Independently reproducible mechanism that permits unique identification of a specific Software Package."@en .


spdx:algorithm vann:usageNote "Mandatory Property - 1..1"@en ;
               rdfs:isDefinedBy spdx: ;
               rdfs:comment "SHA-1 is the only supported algorithm."@en .


spdx:checksum rdfs:isDefinedBy spdx: ;
              vann:usageNote "Optional Property - 0..1"@en ;
              rdfs:comment "Checksum of the distribution."@en .


spdx:checksumValue rdfs:comment "Lower case hexadecimal encoded digest value produced using a specific algorithm."@en ;
                   rdfs:isDefinedBy spdx: ;
                   vann:usageNote "rdfs:Literal typed as xsd:hexBinary. Mandatory Property - 1..1"@en .


rdfs:label rdfs:isDefinedBy rdfs: ;
           rdfs:comment "Label for the File format."@en ,
                        "Label for the Licence."@en ,
                        "Name of the location"@en ;
           vann:usageNote "Recommended Property - 0..n"@en ;
           rdfs:comment "Name of the Theme Taxonomy."@en ,
                        "Name of the Language."@en .


owl:versionInfo vann:usageNote "Optional Property - 0..n"@en ;
                rdfs:comment "Version number or other designation of the Asset."@en ;
                rdfs:isDefinedBy dct: .


skos:Concept rdfs:isDefinedBy skos: ;
             rdfs:comment "Indication of the maturity of an Asset or a Distribution."@en ,
                          "Classification of an Asset according to a controlled vocabulary."@en ,
                          "Concept or subject to which an Asset applies, e.g. 'law' or 'environment'."@en ,
                          "Machine-readable language in which a Distribution is expressed."@en ;
             vann:usageNote "Mandatory class"@en ;
             rdfs:comment "Interoperability Level of the Asset"@en ;
             vann:usageNote "Optional class"@en .


skos:ConceptScheme rdfs:comment "Controlled vocabulary that contains terms that are used as Themes for the Assets in a Repository."@en ;
                   rdfs:isDefinedBy skos: ;
                   vann:usageNote "Optional class"@en .


skos:altLabel rdfs:isDefinedBy dct: ;
              vann:usageNote "Optional Property - 0..n"@en ;
              rdfs:comment "Alternative name for the Asset."@en .


skos:hasTopConcept rdfs:isDefinedBy skos: ;
                   rdfs:comment "Concept that is the top level of the Theme Taxonomy."@en ;
                   vann:usageNote "Recommended Property - 0..n"@en .


skos:inScheme rdfs:comment "Concept scheme in which the Interoperability Level is included."@en ,
                           "Concept scheme in which the Theme is included."@en ,
                           "Concept scheme in which the Status is included."@en ;
              rdfs:isDefinedBy skos: ;
              rdfs:comment "Concept scheme in which the Representation Technique is included."@en ,
                           "Concept scheme in which the Asset Type is included."@en ;
              vann:usageNote "Recommended Property - 0..n"@en .


skos:label rdfs:comment "Label for the Asset Type."@en ,
                        "Label for the Representation Technique."@en ,
                        "Label for the Interoperability Level"@en ;
           vann:usageNote "Recommended Property - 0..n"@en ;
           rdfs:comment "Label for the Status."@en ;
           rdfs:isDefinedBy skos: ;
           rdfs:comment "Label for the Theme."@en .


v:Kind rdfs:isDefinedBy v: ;
       vann:usageNote "Mandatory class"@en ;
       rdfs:comment "Contact point for further information about an Asset."@en .


v:fn rdfs:isDefinedBy v: ;
     rdfs:comment "Full name of the contact."@en ;
     vann:usageNote "Mandatory Property - 1..n"@en .


v:hasAddress vann:usageNote "Optional Property - 0..n"@en ;
             rdfs:isDefinedBy v: ;
             rdfs:comment "Full address of the contact"@en .


v:hasEmail vann:usageNote "Mandatory Property - 1..n"@en ;
           rdfs:comment "e-mail address where comments and question for an Asset or Repository can be sent"@en ;
           rdfs:isDefinedBy v: .


v:hasTelephone vann:usageNote "Optional Property - 0..n"@en ;
               rdfs:comment "Telephone number of the contact"@en ;
               rdfs:isDefinedBy v: .


v:hasURL rdfs:isDefinedBy v: ;
         vann:usageNote "Optional Property - 0..n"@en ;
         rdfs:comment "Webpage of the contact"@en .


adms:includedAsset vann:usageNote "Optional Property - 0..n"@en ;
                   rdfs:isDefinedBy <http://www.w3.org/ns/adms#> ;
                   rdfs:comment "An Asset that is contained in the Asset being described."@en .


adms:representationTechnique rdfs:isDefinedBy <http://www.w3.org/ns/adms#> ;
                             rdfs:comment """Language in which the Distribution is expressed, using a controlled vocabulary - ADMS Representation Technique Vocabulary >> http://purl.org/adms/representationtechnique/ 
	Note: This is different from the file format, e.g. a ZIP file (file format) could contain an XML schema (representation technique) - """@en ;
                             vann:usageNote "Optional Property - 0..1"@en .


adms:status vann:usageNote "Optional Property - 0..1"@en ;
            rdfs:isDefinedBy <http://www.w3.org/ns/adms#> ;
            vann:usageNote "Optional Property - 0..n"@en ;
            rdfs:comment "Description of changes between this version and the previous version of the Asset - ADMS Status vocabulary >> http://purl.org/adms/status/ "@en ,
                         "Status of the Asset in the context of a particular workflow process, using a controlled vocabulary - ADMS Status vocabulary >> http://purl.org/adms/status/ "@en .


adms:translation rdfs:comment "Translation of the Asset."@en ;
                 rdfs:isDefinedBy <http://www.w3.org/ns/adms#> ;
                 vann:usageNote "Optional Property - 0..n"@en .


adms:versionNotes rdfs:comment "Description of changes between this version and the previous version of the Asset."@en ;
                  vann:usageNote "Optional Property - 0..1"@en ;
                  rdfs:isDefinedBy <http://www.w3.org/ns/adms#> .


dcat:Catalog vann:usageNote "Optional class"@en ;
             rdfs:isDefinedBy dcat: ;
             rdfs:comment "System or service that provides facilities for storage and maintenance of descriptions of Assets and Asset Distributions, and functionality that allows users to search and access these descriptions. An Asset Repository will typically contain descriptions of several Assets and related Asset Distributions."@en .


dcat:Dataset vann:usageNote "Mandatory class."@en ;
             rdfs:comment "Abstract entity that reflects the intellectual content of an Asset and represents those characteristics that are independent of its physical embodiment. This abstract entity combines the FRBR  entities work (a distinct intellectual or artistic creation) and expression (the intellectual or artistic realization of a work). The physical embodiment of an Asset is called an Asset Distribution. A particular Asset may have zero or more Distributions."@en ;
             rdfs:isDefinedBy dcat: .


dcat:Distribution vann:usageNote "Recommended class."@en ;
                  rdfs:isDefinedBy dcat: ;
                  rdfs:comment "Particular physical embodiment of an Asset, which is an example of the FRBR entity manifestation (the physical embodiment of an expression of a work). A Distribution is typically a downloadable computer file (but in principle it could also be a paper document or API response) that implements the intellectual content of an Asset. A particular Distribution is associated with one and only one Asset, while all Distributions of an Asset share the same intellectual content in different physical formats."@en .


dcat:accessURL vann:usageNote "Mandatory Property - 1..n"@en ;
               rdfs:comment "URL of the Distribution."@en ;
               rdfs:isDefinedBy dcat: .


dcat:contactPoint vann:usageNote "Mandatory Property - 1..n"@en ,
                                 "Recommended Property - 0..n"@en ;
                  rdfs:comment "Contact point for further information about the Repository."@en ,
                               "Contact point for further information about the Asset, where errors can be reported or suggestions can be made."@en ;
                  rdfs:isDefinedBy dcat: .


dcat:dataset rdfs:isDefinedBy dcat: ;
             vann:usageNote "Recommended Property - 0..n"@en ;
             rdfs:comment "An Asset included in the Repository."@en .


dcat:distribution rdfs:comment "Implementation of the Asset in a particular format."@en ;
                  vann:usageNote "Recommended Property - 0..n"@en ;
                  rdfs:isDefinedBy dcat: .


dcat:keyword vann:usageNote "Recommended Property - 0..n"@en ;
             rdfs:comment "Word of phrase to describe the Asset."@en ,
                          "Word of phrase to describe the Repository."@en ;
             rdfs:isDefinedBy dcat: ;
             vann:usageNote "Optional Property - 0..n"@en .


dcat:landingPage rdfs:isDefinedBy dcat: ;
                 rdfs:comment "Web page that provides access to the asset, its releases, distributions and/or additional information. It is intended to point to a landing page at the original asset provider, not to a page on a site of a third party, such as a catalogue or repository."@en ;
                 vann:usageNote "Recommended Property - 0..1"@en .


dcat:theme rdfs:isDefinedBy dcat: ;
           rdfs:comment "Theme or sector to which the Asset applies, using a controlled vocabulary - Dataset Theme Vocabulary >> http://publications.europa.eu/resource/authority/data-theme ; the values to be used for this property are the URIs of the concepts in the vocabulary"@en ;
           vann:usageNote "Recommended Property - 0..n"@en .


dcat:themeTaxonomy vann:usageNote "Recommended Property - 0..n"@en ;
                   rdfs:isDefinedBy dcat: ;
                   rdfs:comment "Concept Scheme used to classify an Asset Repository's assets, using a controlled vocabulary - Dataset Theme Vocabulary >> http://publications.europa.eu/resource/authority/data-theme; the value to be used for this property is the URI of the vocabulary itself, i.e. the concept scheme, not the URIs of the concepts in the vocabulary."@en .


foaf:Agent rdfs:isDefinedBy foaf: ;
           vann:usageNote "Mandatory class"@en ;
           rdfs:comment "Organisation that makes information available."@en .


foaf:Document rdfs:comment "Document that further describes an Asset or gives guidelines for its use."@en ;
              rdfs:isDefinedBy foaf: ;
              vann:usageNote "Optional class"@en .


foaf:homepage rdfs:isDefinedBy foaf: ;
              rdfs:comment "Web page that gives access to the Repository."@en ;
              vann:usageNote "Recommended Property - 0..1"@en .


foaf:name rdfs:isDefinedBy foaf: ;
          rdfs:comment "Name of the person or organisation."@en ;
          vann:usageNote "Mandatory Property - 1..n"@en .


foaf:page vann:usageNote "Optional Property - 0..n"@en ;
          rdfs:isDefinedBy foaf: ;
          rdfs:comment "Documentation that contains information related to the asset."@en .
`;
export default content ;